export default __webpack_public_path__ + "static/media/86.f7212cee.jpg";